import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("cauldron_token");
    if (!t) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setProfile(data.profile); setWallet(data.wallet);
    } catch {
      localStorage.removeItem("cauldron_token");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cauldron_token", data.token);
    await refresh();
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("cauldron_token", data.token);
    await refresh();
    return data.user;
  };
  // 2FA-enabled signup (email OTP). If the email rail is misconfigured the
  // backend gracefully falls back to creating the user immediately and
  // returns { otpSkipped: true, token, user, message } so we can skip the
  // verify step entirely and log them in.
  const registerStart = async (payload) => {
    const { data } = await api.post("/auth/register/start", payload);
    if (data?.otpSkipped && data?.token) {
      localStorage.setItem("cauldron_token", data.token);
      await refresh();
    }
    return data;
  };
  const registerVerify = async (email, code) => {
    const { data } = await api.post("/auth/register/verify", { email, code });
    localStorage.setItem("cauldron_token", data.token);
    await refresh();
    return data.user;
  };
  const registerResend = async (email) => {
    const { data } = await api.post("/auth/register/resend", { email });
    return data;
  };
  const logout = () => {
    localStorage.removeItem("cauldron_token");
    setUser(null); setProfile(null); setWallet(null);
  };

  return (
    <AuthCtx.Provider value={{ user, profile, wallet, loading, login, register, registerStart, registerVerify, registerResend, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
